import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getOpcoOrganizationMasterServiceAgreementPagePath = (id: string = ':id') => {
  return urlHelper(`/opco/organization/${id}/master-service-agreement`);
};
